/**
 * Trust-strip marquee: loops forever, pauses on hover/focus, and flips direction and speeds up
 * with scroll velocity. Replaces the CSS fallback loop once it runs.
 */
import { gsap } from 'gsap';
import { getLenis } from './lenis.js';

export function initMarquee() {
  document.querySelectorAll('[data-marquee]').forEach((strip) => {
    const track = strip.querySelector('[data-marquee-track]');
    const group = track.children[0];
    strip.classList.add('is-js');

    const BASE = 60; // px per second
    let x = 0;
    let direction = -1;
    let speed = 1;
    let target = 1;
    let width = group.offsetWidth;
    const wrap = () => gsap.utils.wrap(-width, 0);
    let wrapX = wrap();

    new ResizeObserver(() => { width = group.offsetWidth; wrapX = wrap(); }).observe(group);

    const pause = () => { target = 0; };
    const play = () => { target = 1; };
    strip.addEventListener('pointerenter', pause);
    strip.addEventListener('pointerleave', play);
    strip.addEventListener('focusin', pause);
    strip.addEventListener('focusout', play);

    let lastScroll = window.scrollY;
    gsap.ticker.add((time, delta) => {
      const lenis = getLenis();
      const y = window.scrollY;
      const velocity = lenis ? lenis.velocity : y - lastScroll;
      lastScroll = y;
      if (Math.abs(velocity) > 0.5) direction = velocity > 0 ? -1 : 1;
      const boost = Math.min(Math.abs(velocity) * 0.25, 6);
      speed += ((target * (1 + boost)) - speed) * 0.08;
      x = wrapX(x + direction * BASE * speed * (delta / 1000));
      track.style.transform = `translate3d(${x}px, 0, 0)`;
    });
  });
}
